import { isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { WebtrekkConfigService } from 'src/app/webtrekk-config.service';

@Injectable({ providedIn: 'root' })
export class CheckAvailabilityWebtrekkTrackingService {
    platformId = inject(PLATFORM_ID);
    constructor(
        private webtrekk: WebtrekkConfigService) { }

    trackAction(page: string, orderType: string, productCode: string, qty: number, isAvailable: boolean, isPartialAvailable: boolean,
        stockRes: any[], countryCode, currentB2bUnitSendToWebtrack: string) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }// SSR-safe

        let actionName = `${page}_orderType_${productCode}_${orderType}_${qty}`;

        if (isAvailable || isPartialAvailable) {
            actionName += '_available';
        } else if (stockRes.length === 0 || (!isAvailable && !isPartialAvailable)) {
            actionName += '_not_available';
        }

        stockRes.forEach(element => {
            actionName += `_${element.stock.stockLevel}_${element.formattedDate}`;
        });

        this.webtrekk.runWhenReady(() => {
            (window as any).wtSmart?.action?.data?.set({
                name: actionName,
                parameter: {
                    4: orderType,
                    3: productCode,
                    5: qty,
                    6: stockRes[0]?.stock?.stockLevel,
                    7: countryCode,
                    8: currentB2bUnitSendToWebtrack
                }
            });
            (window as any).wtSmart?.track();
        })

    }
}
